import { render } from "./AttractionList.vue?vue&type=template&id=745454a2&scoped=true"
import script from "./AttractionList.vue?vue&type=script&lang=js"
export * from "./AttractionList.vue?vue&type=script&lang=js"

import "./AttractionList.vue?vue&type=style&index=0&id=745454a2&lang=scss&scoped=true"

import exportComponent from "/home/duanpengyuan/Projects/dcp-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745454a2"]])

export default __exports__